export default {
    all: 'Tous',
    finance: 'Crédit',
    followUp: 'Suivi',
    general: '@.capitalize:lexicon.divisions.general',
    new: 'Neuf',
    none: 'Aucune',
    parts: 'Pièces',
    reception: 'Réception',
    revival: 'Relance',
    service: 'Service',
    used: 'Occasion',
    bdc: 'BDC',
};
